import React from 'react'

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  value?: string
  inputSize?: 'xs' | 'sm' | 'md' | 'lg'
  isInvalid?: boolean
}

export const Checkbox = ({
  id,
  value,
  label,
  inputSize: size,
  isInvalid,
  className,
  children,
  ...props
}: React.PropsWithChildren<CheckboxProps>): React.ReactElement => {
  id = id || ['checkbox', value].join('-')
  return (
    <div
      className={['form-check ms-2', size ? `form-check-${size}` : '', className]
        .filter(Boolean)
        .join(' ')}
    >
      <input
        {...props}
        id={id}
        value={value}
        type="checkbox"
        className={`form-check-input` + (isInvalid ? ' is-invalid' : '')}
      />
      <label className="form-check-label d-block" htmlFor={id}>
        {children || label}
      </label>
    </div>
  )
}
